import { Button, Col, Divider, Form, Select, Row, Switch } from 'antd';
import React, { useEffect } from 'react';

import { useQuery } from 'react-query';
import CardCollapse from '../../../../components/CardCollapse';
import { useApi } from '../../../../hooks/useApi';
import { usePermission } from '../../../../hooks/usePermissions';
import api from '../../../../services/api';
import EnumChargeOptionsDescriptionPattern from '../../../../types/enum/ChargeOptionsDescriptionPattern';

type IProps = {
  loading: boolean;
  id_usuario: string;
  configuracao?: any;
};

const CardConfiguration: React.FC<IProps> = ({
  id_usuario,
  configuracao,
  loading,
}: IProps) => {
  const [form] = Form.useForm();
  const [formBlockEstablishmentPaymentAutomatic] = Form.useForm();
  const [form3ds] = Form.useForm();
  const [formNotification] = Form.useForm();
  const [formSettlementAutomatic] = Form.useForm();
  const [formFeesChargeOptions] = Form.useForm();
  const [formChargeOptionsDescription] = Form.useForm();

  const { fetchRequest, loading: fetchLoading } = useApi();
  const { fetchRequest: updateConfig3ds, loading: loading3Ds } = useApi();
  const {
    fetchRequest: updateConfigNotification,
    loading: updatingSettingNotitfication,
  } = useApi();
  const {
    fetchRequest: fetchRequestSettlementAutomatic,
    loading: fetchLoadingSettlementAutomatic,
  } = useApi();
  const {
    fetchRequest: fetchRequestFeesChargeOptions,
    loading: fetchLoadingFeesChargeOptions,
  } = useApi();
  const {
    fetchRequest: updateChargeOptionsDescription,
    loading: loadingUpdateChatrgeOptionsDescription,
  } = useApi();
  const { userPermissions } = usePermission();

  useQuery({
    queryKey: ['establishment-info', id_usuario],
    queryFn: async () => {
      const response = await api.get<{
        run_risk_analysis: boolean;
        send_notifications: boolean;
        run_three_ds: boolean;
        settlement_automatic: boolean;
        show_fees_charge_options: boolean;
        charge_options_description_pattern: EnumChargeOptionsDescriptionPattern;
      }>(`/backoffice/establishment/${id_usuario}`);

      return response.data;
    },
    onSuccess({
      run_risk_analysis,
      run_three_ds,
      send_notifications,
      settlement_automatic,
      show_fees_charge_options,
      charge_options_description_pattern,
    }) {
      form.setFieldsValue({ run_risk_analysis });
      form3ds.setFieldsValue({ run_three_ds });
      formNotification.setFieldsValue({ send_notifications });
      formSettlementAutomatic.setFieldsValue({ settlement_automatic });
      formFeesChargeOptions.setFieldsValue({ show_fees_charge_options });
      formChargeOptionsDescription.setFieldsValue({
        charge_options_description_pattern,
      });
    },
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: 0,
  });

  async function updateRiskAnalysFlag(data: any) {
    fetchRequest({
      method: 'put',
      url: `/backoffice/establishment/${id_usuario}/config`,
      data,
      messages: {
        loading: 'Atualizando configurações, aguarde...',
        success: `Análise de Risco ${
          data.run_risk_analysis ? 'ativado' : 'desativado'
        }!`,
      },
    });
  }
  async function updateRunThreeDs(data: any) {
    updateConfig3ds({
      method: 'put',
      url: `/backoffice/establishment/${id_usuario}/config`,
      data,
      messages: {
        loading: 'Atualizando configurações, aguarde...',
        success: `3DS ${data.run_three_ds ? 'ativado' : 'desativado'}!`,
      },
    });
  }
  async function updateNotifications(data: any) {
    updateConfigNotification({
      method: 'put',
      url: `/backoffice/establishment/${id_usuario}/config`,
      data,
      messages: {
        loading: 'Atualizando configurações, aguarde...',
        success: `Notificações ${
          data.send_notifications ? 'ativadas' : 'desativada'
        }!`,
      },
    });
  }

  async function updateSettlementAutomatic(data: any) {
    fetchRequestSettlementAutomatic({
      method: 'put',
      url: `/backoffice/establishment/${id_usuario}/config`,
      data,
      messages: {
        loading: 'Atualizando configurações, aguarde...',
        success: `Liquidacao automática ${
          data.settlement_automatic ? 'ativadas' : 'desativada'
        }!`,
      },
    });
  }

  async function updateShowFeesChargeOptions(data: any) {
    fetchRequestFeesChargeOptions({
      method: 'put',
      url: `/backoffice/establishment/${id_usuario}/config`,
      data,
      messages: {
        loading: 'Atualizando configurações, aguarde...',
        success: `Taxas ${
          data.show_fees_charge_options ? 'ativadas' : 'desativada'
        }!`,
      },
    });
  }

  async function updateChargeOptionsDescriptionPattern(
    data: EnumChargeOptionsDescriptionPattern,
  ) {
    updateChargeOptionsDescription({
      method: 'put',
      url: `/backoffice/establishment/${id_usuario}/config`,
      data: {
        charge_options_description_pattern: data,
      },
      messages: {
        loading: 'Atualizando configurações, aguarde...',
        success: `Exibição das taxas modificado com sucesso!`,
      },
    });
  }

  useEffect(() => {
    form.setFieldsValue(configuracao);
    formBlockEstablishmentPaymentAutomatic.setFieldsValue(configuracao);
  }, [configuracao]);

  return (
    <CardCollapse title="Configurações" loading={loading}>
      <Row
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginLeft: 20,
        }}
      >
        <Col style={{ display: 'flex', flex: 1 }}>
          <Form layout="horizontal" form={form} onFinish={updateRiskAnalysFlag}>
            <Form.Item
              label="Utiliza Análise de Risco"
              name="run_risk_analysis"
              valuePropName="checked"
            >
              <Switch loading={fetchLoading} />
            </Form.Item>

            {userPermissions.TAXA_ADICIONAR && userPermissions.TAXA_REMOVER ? (
              <>
                <br />

                <Button type="primary" htmlType="submit" loading={fetchLoading}>
                  Salvar
                </Button>
              </>
            ) : null}
          </Form>
        </Col>
        <Col style={{ display: 'flex', flex: 1 }}>
          <Form layout="horizontal" form={form3ds} onFinish={updateRunThreeDs}>
            <Form.Item
              label="Utiliza 3DS"
              name="run_three_ds"
              valuePropName="checked"
            >
              <Switch loading={loading3Ds} />
            </Form.Item>
            <br />

            <Button type="primary" htmlType="submit" loading={loading3Ds}>
              Salvar
            </Button>
          </Form>
        </Col>
      </Row>

      <Divider />

      <Row
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginLeft: 20,
        }}
      >
        <Col style={{ display: 'flex', flex: 1 }}>
          <Form
            layout="horizontal"
            form={formNotification}
            onFinish={updateNotifications}
          >
            <Form.Item
              label="Envie notificações"
              name="send_notifications"
              valuePropName="checked"
            >
              <Switch loading={updatingSettingNotitfication} />
            </Form.Item>
            <br />

            <Button
              type="primary"
              htmlType="submit"
              loading={updatingSettingNotitfication}
            >
              Salvar
            </Button>
          </Form>
        </Col>
        <Col style={{ display: 'flex', flex: 1 }}>
          <Form
            layout="horizontal"
            form={formSettlementAutomatic}
            onFinish={updateSettlementAutomatic}
          >
            <Form.Item
              label="Liquidação Automática"
              name="settlement_automatic"
              valuePropName="checked"
            >
              <Switch loading={fetchLoadingSettlementAutomatic} />
            </Form.Item>
            <br />

            <Button
              type="primary"
              htmlType="submit"
              loading={fetchLoadingSettlementAutomatic}
            >
              Salvar
            </Button>
          </Form>
        </Col>
        {/* <Col style={{ display: 'flex', flex: 1 }}>
          <Form
            layout="horizontal"
            form={formBlockEstablishmentPaymentAutomatic}
            onFinish={updateBlockEstablishmentPaymentAutomatic}
          >
            <Form.Item
              label="Bloqueia liquidação automática (POS)"
              name="is_blocked_payment_automatic"
              valuePropName="checked"
            >
              <Switch
                loading={fetchLoadingBlockEstablishmentPaymentAutomatic}
              />
            </Form.Item>

            {userPermissions.TAXA_ADICIONAR && userPermissions.TAXA_REMOVER ? (
              <>
                <br />

                <Button
                  type="primary"
                  htmlType="submit"
                  loading={fetchLoadingBlockEstablishmentPaymentAutomatic}
                >
                  Salvar
                </Button>
              </>
            ) : null}
          </Form>
        </Col> */}
      </Row>

      <Divider />

      <Row
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginLeft: 20,
        }}
      >
        <Col style={{ display: 'flex', flex: 1 }}>
          <Form
            layout="horizontal"
            form={formFeesChargeOptions}
            onFinish={updateShowFeesChargeOptions}
          >
            <Form.Item
              label="Mostrar taxas"
              name="show_fees_charge_options"
              valuePropName="checked"
            >
              <Switch loading={fetchLoadingFeesChargeOptions} />
            </Form.Item>
            <br />

            <Button
              type="primary"
              htmlType="submit"
              loading={fetchLoadingFeesChargeOptions}
            >
              Salvar
            </Button>
          </Form>
        </Col>
        <Col
          style={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
          }}
        >
          <Form layout="vertical" form={formChargeOptionsDescription}>
            <Form.Item name="charge_options_description_pattern">
              <Select
                placeholder="Selecione o formato das opções de cobrança"
                onSelect={e => updateChargeOptionsDescriptionPattern(e)}
                loading={loadingUpdateChatrgeOptionsDescription}
                style={{ maxWidth: '20rem' }}
              >
                <Select.Option
                  value={
                    EnumChargeOptionsDescriptionPattern.INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT_FEE_PERCENTAGE
                  }
                >
                  Qtd Parcelas X R$ Valor Parcelas (Taxa em %) (Ex. 1 x R$
                  100,00 (4,3 %))
                </Select.Option>
                <Select.Option
                  value={
                    EnumChargeOptionsDescriptionPattern.INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT
                  }
                >
                  Número de Parcelas X R$ Valor Parcela (Ex. 1 x R$ 100,00)
                </Select.Option>
                <Select.Option
                  value={
                    EnumChargeOptionsDescriptionPattern.TYPE_INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT
                  }
                >
                  Tipo e Número de Parcelas X R$ Valor Parcela (Ex. Crédito 6 x
                  R$ 150,00)
                </Select.Option>
                <Select.Option
                  value={
                    EnumChargeOptionsDescriptionPattern.TYPE_INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT_FEE_PERCENTAGE
                  }
                >
                  Tipo e Número de Parcelas X R$ Valor Parcela (Taxa em %) (Ex.
                  Crédito 6 x R$ 150,00 (4,3 %))
                </Select.Option>
              </Select>
            </Form.Item>

            <br />
          </Form>
        </Col>
      </Row>
    </CardCollapse>
  );
};

export default CardConfiguration;
